import { Component, OnDestroy, OnInit } from '@angular/core';

// App-wide "you're offline" banner — most relevant on a kiosk/gate device
// that might sit on flaky wifi for hours unattended, but genuinely useful
// for any role: silent failed requests are far more confusing than a
// visible "you're offline" state.
@Component({
  selector: 'app-connection-status',
  templateUrl: './connection-status.component.html',
  styleUrls: ['./connection-status.component.scss'],
})
export class ConnectionStatusComponent implements OnInit, OnDestroy {
  isOffline = !navigator.onLine;
  // Briefly shown after reconnecting, then auto-dismissed — confirms the
  // connection came back rather than just silently removing the banner.
  justReconnected = false;

  private onlineHandler = () => this.handleOnline();
  private offlineHandler = () => this.handleOffline();
  private reconnectTimeout: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
    window.addEventListener('online', this.onlineHandler);
    window.addEventListener('offline', this.offlineHandler);
  }

  private handleOffline(): void {
    this.isOffline = true;
    this.justReconnected = false;
  }

  private handleOnline(): void {
    this.isOffline = false;
    this.justReconnected = true;
    this.reconnectTimeout = setTimeout(() => (this.justReconnected = false), 3000);
  }

  ngOnDestroy(): void {
    window.removeEventListener('online', this.onlineHandler);
    window.removeEventListener('offline', this.offlineHandler);
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
    }
  }
}
